 import React, {useState} from 'react';
import {IObjectSelectProps} from '../ObjectSelect';
import {IClassNameProps, withBemMod} from '@bem-react/core';
import {cnObjectSelect} from '../index';
import {useTranslation} from 'react-i18next';
import {useSelector} from "react-redux";
import {IFacadeMaterialData} from '../../../../../common-code/interfaces/materials/IFacadeMaterialData';
import {IFacadeData} from '../../../../../common-code/interfaces/materials/IFacadeData';
import {AppState} from '../../../../redux/AppStore';
import {ObjectSelectSelect} from '../Select/ObjectSelect-Select';
import {Modal} from '../../Modal';
import {FacadeMaterials} from '../../../elements/FacadeMaterials/FacadeMaterials';
import {cnFacadeMaterials} from '../../../elements/FacadeMaterials';
import {
    OBJECT_SELECT_TYPE_FACADE_MATERIAL
} from '../../../../constants';
 import {IDataObjectSelectSelect} from '../../../../interfaces/IDataObjectSelectSelect';
 import {IMaterialData} from '../../../../../common-code/interfaces/materials/IMaterialData';
 import {NONE_MATERIAL} from '../../../../../common-code/constants';

const ObjectSelectFacadeMaterial: React.FC<IObjectSelectProps<IFacadeMaterialData>> =
    ({
         data,
         list,
         onSelectObject,
         service,
         className,
        title,
     }) => {
        const {t} = useTranslation();
        const facades: IFacadeData[] | undefined = useSelector((state: AppState) => state.wizard.facades);
        const allMaterials: IMaterialData[] | undefined = useSelector((state: AppState) => state.wizard.materials);
        const [showModal, setShowModal] = useState<boolean>(false);

        if (!facades) {
            return null;
        }

        const emptyObjectData: IFacadeMaterialData = {
            id: 'none',
            title: t('Не выбрано'),
            facade: 'none',
            material: 'none',
            image: '',
        };
        const getMaterial =(materialId: string, allMaterials?: IMaterialData[]): IMaterialData | undefined => {
            let material: IMaterialData;

            if (!materialId || !materialId.length || materialId === NONE_MATERIAL) {
                return undefined;
            }
            if (allMaterials) {
                for (material of allMaterials) {
                    if (material.id === materialId) {
                        return material;
                    }
                }
            }

            return undefined;
        }
        const objectData: IFacadeMaterialData = data && data.object ? data.object : emptyObjectData;
        const materialData: IMaterialData | undefined = getMaterial(objectData.material, allMaterials);

        const getObjectImage = (
            objectData: IFacadeMaterialData,
            materialData: IMaterialData | undefined
        ): string | undefined => {
            if ((!objectData.image || !objectData.image.length) && materialData) {
                return materialData.image;
            }
            return objectData.image;
        }

        const getObjectColor = (
            objectData: IFacadeMaterialData,
            materialData: IMaterialData | undefined
        ): string | undefined => {
            if (getObjectImage(objectData, materialData)) {
                return undefined;
            }
            if (materialData) {
                return materialData.color;
            }

            return undefined;
        }
        const getObjectIcon = (
            objectData: IFacadeMaterialData,
            materialData: IMaterialData | undefined
        ): string | undefined => {
            if (!getObjectColor(objectData, materialData) && !getObjectImage(objectData, materialData)) {
                return 'no-photo';
            }

            return undefined;
        }

        const renderObjectImage = (title: string, image: string | undefined): IDataObjectSelectSelect | undefined => {
            if (image) {
                return {path: image, label: t(title), width: 60, height: 60}
            }
            return undefined;
        }

        return (
            <div className={cnObjectSelect({}, [className])}>
                <ObjectSelectSelect
                    className={cnObjectSelect('Select')}
                    image={renderObjectImage(objectData.title, getObjectImage(objectData, materialData))}
                    color={renderObjectImage(objectData.title, getObjectColor(objectData, materialData))}
                    icon={renderObjectImage(objectData.title, getObjectIcon(objectData, materialData))}
                    title={t('Фасад') || undefined}
                    description={objectData.title}
                    callBack={() => {
                        setShowModal(true)
                    }}
                />
                {showModal ?
                    <Modal
                        className={cnObjectSelect('Modal')}
                        visible={showModal}
                        callBack={setShowModal}
                        size={'full'}
                    >
                        {!list || !onSelectObject ?
                            <div className={cnObjectSelect('Error')}>{t('Загрузка данных')}...</div> :
                            <FacadeMaterials
                                className={cnObjectSelect(cnFacadeMaterials())}
                                listMaterialData={list}
                                materialData={objectData}
                                listFacadeData={facades}
                                title={title}
                                onSelectObject={onSelectObject}
                                service={service}
                            />
                        }
                    </Modal> : null
                }
            </div>
        );
    }

export const withObjectSelectFacadeMaterial = withBemMod<IObjectSelectProps<IFacadeMaterialData>, IClassNameProps>(
    cnObjectSelect(),
    {type: OBJECT_SELECT_TYPE_FACADE_MATERIAL},
    () => ObjectSelectFacadeMaterial
);